import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { connect, actions } from '../../../../Store';
import { getIdFromProps } from '../../../../Utils';
import ProductRows from '../Rows';

const MainContainer = styled.div`
  padding: ${rem(16)};
`;

class InvoiceDetail extends React.Component {
  state = {
    ids: [],
  };

  async componentDidMount() {
    const id = getIdFromProps(this.props);
    await this.fetchData(id);

    actions.setActiveMenuItem('43');
  }

  async fetchData(id) {
    let ids = [];

    if (id === 'detail' && this.props.location.state) {
      ids = [this.props.location.state.ids];
    } else {
      ids = [id];
    }

    this.setState({
      ids,
    });
  }

  render() {
    const { ids } = this.state;

    return (
      <MainContainer>
        <ProductRows ids={ids} />
      </MainContainer>
    );
  }
}

InvoiceDetail.propTypes = {
  location: PropTypes.shape.isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InvoiceDetail);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Quotes/Detail/index.jsx